export default __webpack_public_path__ + "static/media/output.98df7c83.svg";